import { render, staticRenderFns } from "./TheHomeVideos.vue?vue&type=template&id=361ca145&scoped=true"
var script = {}
import style0 from "./TheHomeVideos.vue?vue&type=style&index=0&id=361ca145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361ca145",
  null
  
)

export default component.exports